import * as tslib_1 from "tslib";
/* I32B in DS */
import React from 'react';
import IconWrap from '../IconWrap';
var instances = 0;
var CloseBig = /** @class */ (function (_super) {
    tslib_1.__extends(CloseBig, _super);
    function CloseBig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.instanceId = instances++;
        return _this;
    }
    CloseBig.prototype.render = function () {
        return (React.createElement(IconWrap, tslib_1.__assign({}, this.props),
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "0", height: "0", viewBox: "0 0 24 24" },
                React.createElement("defs", null,
                    React.createElement("path", { id: "i32-b-" + this.instanceId, d: "M13.765 12L22 20.235 20.235 22 12 13.765 3.765 22 2 20.235 10.235 12 2 3.765 3.765 2 12 10.235 20.235 2 22 3.765 13.765 12z" })),
                React.createElement("g", { fillRule: "evenodd" },
                    React.createElement("use", { fill: "currentColor", xlinkHref: "#i32-b-" + this.instanceId })))));
    };
    return CloseBig;
}(React.Component));
export { CloseBig };
export default CloseBig;
//# sourceMappingURL=CloseBig.js.map